export const speakers = [
  {
    name: "HE Sheikh Bandar bin Mohammed bin Saoud Al-Thani",
    role: "Governor, Qatar Central Bank",
  },
  { name: "Dr. Tamy Bin Ahmed Bin Ali Al-Binali", role: "CEO, Qatar Financial Markets Authority" },
  { name: "Jalil Tarif", role: "Secretary General, Union of Arab Securities Authorities (UASA)" },
  { name: "Tajinder Singh", role: "Deputy Secretary General, IOSCO" },
  { name: "Nezha Hayat", role: "Chairwoman of AMERC — Chairwoman of AMMC, Morocco" },
  {
    name: "Dr. Mohamed Farid Saleh",
    role: "Executive Chairman, Egypt Financial Regulatory Authority",
  },
  { name: "Khaled Alhomoud", role: "Member of the Board of Commissioners, CMA (Saudi Arabia)" },
  { name: "Nandini Sukumar", role: "CEO, The World Federation of Exchanges" },
  { name: "Fianna Jurdant", role: "Senior Policy Analyst, OECD" },
  { name: "Wolfgang Engel", role: "General Manager, IIF MEA" },
  {
    name: "Dr. Konstantin Saroyan",
    role: "Secretary General, Federation of Euro-Asian Stock Exchanges",
  },
  { name: "Sallianne Taylor", role: "Principal Advisor, Bloomberg" },
  { name: "Elisabeth Wallace", role: "Associate Director, Dubai Financial Services Authority" },
  { name: "John Turner", role: "CEO, XBRL International" },
  { name: "Mirna Sleiman", role: "Founder & CEO, Fintech Galaxy" },
  { name: "Sylvain Bigaud", role: "Regional Head — Middle East, Africa & Turkey, Euroclear" },
  { name: "Ralph Stobwasser", role: "Head of Financial Crime Advisory, Deloitte Middle East" },
  { name: "Rawan Oueidat", role: "Director, S&P Global Ratings — Corporate Ratings, CFA" },
  { name: "Stephen Fisher", role: "Global Head of Government & Public Affairs, Deutsche Bank" },
  { name: "Ahmed Al-Kiswani", role: "Partner, PwC Middle East" },
  { name: "Michael P. Grifferty", role: "President, Gulf Capital Market Association" },
  { name: "Dr. Ahmad Tarablsi", role: "AAOIFI (ERC) Board Member" },
  { name: "Shawki G. Ahwash", role: "AML, CFT & Sanction Expert" },
  { name: "Abbas A. Bou Diab", role: "Executive Manager, Blom Bank" },
];

export const agenda = [
  {
    time: "08:30 – 09:30",
    title: "Registration & Welcome Coffee",
    desc: "Delegates check-in and networking.",
  },
  {
    time: "09:30 – 10:00",
    title: "Opening Ceremony & Keynote Addresses",
    desc: "Welcome remarks from UASA and QFMA leadership.",
  },
  {
    time: "10:00 – 11:15",
    title: "Session I — Strategic Growth of Arab Capital Markets",
    desc: "Challenges and opportunities for regional growth.",
  },
  { time: "11:15 – 11:45", title: "Coffee Break", desc: "" },
  {
    time: "11:45 – 13:00",
    title: "Session II — Innovation & Artificial Intelligence",
    desc: "AI's transformative role across capital markets.",
  },
  { time: "13:00 – 14:30", title: "Lunch & Networking", desc: "" },
  {
    time: "14:30 – 15:45",
    title: "Session III — Sustainability & ESG Disclosure",
    desc: "Enhancing transparency and sustainable finance.",
  },
  {
    time: "15:45 – 17:00",
    title: "Session IV — Financial Crimes & Investor Protection",
    desc: "AML, CFT and safeguarding investors.",
  },
  { time: "17:00 – 17:30", title: "Closing Remarks", desc: "Summary and next steps." },
];

export const sponsors = [
  { name: "Qatar Financial Markets Authority" },
  { name: "Union of Arab Securities Authorities" },
  { name: "Qatar Stock Exchange" },
  { name: "Edaa" },
  { name: "Deloitte" },
  { name: "PwC Middle East" },
  { name: "Bloomberg" },
  { name: "S&P Global" },
];

export function initials(name: string) {
  return name
    .replace(/HE |Dr\. |Mr\. |Ms\. /g, "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join("");
}

export const REGISTER_URL = "https://forms.office.com/r/3QSEweH5rK";
